module.exports = __webpack_public_path__ + "static/img/dang.3d7d27e.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/dang.png
// module id = vOD3
// module chunks = 51